function hasNullRequiredValues(details) {
  const requiredFields = [
    'firstName',
    'lastName',
    'address',
    'city',
    'zipCode',
    'countryId',
  ]

  return requiredFields.some((field) => details[field] === null || details[field] === undefined)
}

export default hasNullRequiredValues
